export const CART_COOKIE = 'gathrCart'; // Named by us
export const SESSION_COOKIE = '__session'; // Defined by Hydrogen
export const SEARCHSPRING_SESSION_COOKIE = 'ssSessionIdNamespace'; // From https://docs.searchspring.com/reference/get-search
export const SEARCHSPRING_USER_COOKIE = 'ssUserId'; // " "
